import { render } from "./FormVueSelectIndicator.vue?vue&type=template&id=33f4c9d5"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__